// export const PIXELS_PER_UNIT = 0.01;
// export const PIXELS_PER_UNIT = 0.05;
// export let MILES_PER_UNIT = 1000;
// export const KM_PER_MILE = 1.60934;

export const Units = {
    PIXELS_PER_UNIT: 1,
    METERS_PER_UNIT: 1
}

export const TEAM_MAX_SEATS = 5;